module.exports = __webpack_public_path__ + "static/media/aam-marriage.4aaa4dfa.jpg";